






























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { CalendarDay } from '@/model/calendar/CalendarDay';
import { CalendarRange } from '@/model/calendar/CalendarRange';
import isoWeek from "dayjs/plugin/isoWeek";
import dayjs from 'dayjs';

dayjs.extend(isoWeek);

@Component
export default class CalendarPanel extends Vue {

    private static readonly CALENDAR_SETTINGS: any = {
        DAYS: ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'],
        MONTHS: ["Janv.", "Fevr.", "Mars", "Avr.", "Mai", "Juin", "Juil.", "Aout", "Sept.", "Oct.", "Nov.", "Dec."],
    };
    private static readonly NB_DAYS_IN_CALENDAR: number = 42;
    private static readonly VALUE_TO_CALCULTATE_FIRST_MONDAY_INDEX: number = 2

    private selectedYear: number = new Date().getFullYear();
    private selectedMonth: number = new Date().getMonth();
    private renderDays: CalendarDay[] = [];
    private selected: CalendarRange = new CalendarRange();

    @Prop({default: []}) knownRanges: CalendarRange[];

    created() {
        this.renderCalendar();
    }

    @Watch('selectedMonth')
    @Watch('selectedYear')
    @Watch('knownRanges')
    renderCalendar(){
        // If we admit each day in a week has a value. Monday has 1 and Sunday has 7
        // It calculates a number which determines the date of the Monday in the first week when rendering calendar.
        // e.g. : first day of month is Friday (number 5) => 2 - 5 = -3. 
        // So we can calculate which date was Monday for the first week (new Date(year, month, -3)). Monday was last month.
        const firstWeekMondayIndex = CalendarPanel.VALUE_TO_CALCULTATE_FIRST_MONDAY_INDEX - dayjs().year(this.selectedYear).month(this.selectedMonth).startOf("month").isoWeekday();
        this.renderDays = [];
        for (let i = firstWeekMondayIndex, index = 0; index < CalendarPanel.NB_DAYS_IN_CALENDAR; i++, index++) {
            const day = new Date(this.selectedYear, this.selectedMonth, i);
            const calObj = {
                label: day.getDate(),
                date: day,
                isCurrentMonth: day.getMonth() === this.selectedMonth,
                isBeforeToday: dayjs(day).isBefore(dayjs(), "day"),
                isSelected: false,
                isLimit: this.isLimitInRange(day),
                isInRange: this.isInRange(day),
            }
            this.renderDays.push(calObj)
        }
    }

    toggleSelect(item : CalendarDay) {
        if(item.isBeforeToday || !item.isCurrentMonth){
            return;
        }

        item.isSelected = true;
        if(!this.selected.startDate){
            this.selected.startDate = item.date;
            return;
        }

        if(this.selected.startDate > item.date){
            this.selected.endDate = this.selected.startDate;
            this.selected.startDate = item.date;
        }else{
            this.selected.endDate = item.date;
        }
        this.confirmSelection();
    }

    confirmSelection(){
        if(this.selected.startDate != null && this.selected.endDate != null){
            this.$emit("selected", this.selected);
        }
        this.resetSelection();
    }

    resetSelection(){
        this.selected = new CalendarRange();
        this.renderCalendar();
    }

    previousMonth(){
        this.selectedMonth--;
        if (this.selectedMonth < 0) {
            this.selectedMonth = 0;
            this.previousYear();
        } 
    }

    nextMonth(){
        this.selectedMonth++;
        if (this.selectedMonth > 11) {
            this.selectedMonth = 0;
            this.nextYear();
        } 
    }

    nextYear(){
        this.selectedYear++;
    }

    previousYear(){
        this.selectedYear--;
    }

    isLimitInRange(day: Date){
        return day.getMonth() === this.selectedMonth 
            && this.knownRanges.some(x => dayjs(x.startDate).isSame(dayjs(day), "day") || dayjs(x.endDate).isSame(dayjs(day), "day"));
    }

    isInRange(day: Date){
        return day.getMonth() === this.selectedMonth 
            && this.knownRanges.some(x => x.startDate < day && x.endDate > day);
    }

    getCalendarSettings(){
        return CalendarPanel.CALENDAR_SETTINGS;
    }

}
